import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { reviews } from "@/data/siteConfig";
import { SectionHeader } from "@/components/SectionHeader";
import { ReviewCard } from "@/components/ReviewCard";
import { RevealGroup, RevealItem } from "@/components/Reveal";

export const ReviewsPreview = () => (
  <section className="grain relative bg-bone py-24 md:py-32" data-testid="reviews-preview">
    <div className="relative z-10 mx-auto max-w-[1440px] px-5 md:px-8">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <SectionHeader
          light
          overline="Reviews"
          title="What customers say"
          description="Real, unedited feedback from customers across Southern California — especially for difficult safe work."
        />
        <Link
          to="/reviews"
          data-testid="reviews-all-link"
          className="group inline-flex items-center gap-2 font-heading text-sm font-bold uppercase tracking-wide text-ink transition-colors hover:text-gold-dark"
        >
          Read More Customer Reviews
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </div>

      <RevealGroup className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {reviews.map((r, i) => (
          <RevealItem key={i}>
            <ReviewCard review={r} />
          </RevealItem>
        ))}
      </RevealGroup>
    </div>
  </section>
);
